import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SharedServicesComponent } from './shared-services.component';
import { SharedServiceDetailsComponent } from './shared-service-details/shared-service-details.component';
const routes: Routes = [
  {
    path: '',
    component: SharedServicesComponent,
    title: 'Tenant Shared Services'
  },
  {
    path: ':envt',
    component: SharedServiceDetailsComponent,
    title: 'Tenant Shared Services'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SharedServicesRoutingModule { }
